import React from "react";

interface IconProps {
  size?: number;
  className?: string;
}

// Coding Ninjas — circle icon with ninja eyes (symbol only)
export const CodingNinjasIcon: React.FC<IconProps> = ({ size = 48, className }) => (
  <svg width={size} height={size} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <circle cx="13" cy="13" r="13" fill="currentColor" opacity="0.15"/>
    <circle cx="13" cy="13" r="12.5" stroke="currentColor" strokeWidth="0.5" opacity="0.3"/>
    <path d="M4.65 13.04C4.61 14.37 4.84 15.69 5.27 16.97C5.65 18.06 6.38 19 7.35 19.66C8.46 20.36 9.74 20.63 11.08 20.63H19.28V16.73H11.07C9.06 16.73 8.1 15.35 8.1 13.05V13.05C8.1 10.75 9.06 9.38 11.07 9.38H19.28V5.47H11.08C9.78 5.47 8.46 5.74 7.35 6.44C6.38 7.11 5.65 8.04 5.27 9.13C4.84 10.42 4.61 11.74 4.65 13.06" fill="currentColor"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M9.63 12.24L13.48 12.99C13.48 12.99 10.66 15.95 9.63 12.24Z" fill="#030108"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M18.66 12.25L14.93 13.04C14.93 13.04 18.16 15.98 18.66 12.25Z" fill="#030108"/>
  </svg>
);

// Adobe — brand red rounded square with the white 'A' mark
export const AdobeIcon: React.FC<IconProps> = ({ size = 48, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect x="0" y="0" width="24" height="24" rx="5" fill="currentColor" />
    {/* Adobe 'A': right stroke, left stroke, centre chevron */}
    <g transform="translate(2.55 2.55) scale(0.0369)" fill="white">
      <path d="M315.5 64h170.9v384L315.5 64z" />
      <path d="M196.5 64H25.6v384L196.5 64z" />
      <path d="M256 206.1L363.5 448h-70.4l-32.1-81.1h-78.7L256 206.1z" />
    </g>
  </svg>
);

// Naukri / Infoedge — the blue circle mark with swoosh + dot
export const NaukriIcon: React.FC<IconProps> = ({ size = 48, className }) => (
  <svg width={size} height={size} viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <circle cx="11.3" cy="11.3" r="11.3" fill="currentColor"/>
    <path d="M14.69 15.46L14.66 16.61L14.59 19.91V20.04C9.01 15.21 8.06 14.03 7.89 13.67L7.89 13.66C7.87 13.59 7.86 13.52 7.87 13.45C7.88 13.42 7.88 13.4 7.89 13.37C7.9 13.35 7.9 13.33 7.91 13.31C7.97 13.16 8.05 13.01 8.16 12.88C8.24 12.78 8.32 12.68 8.41 12.6C8.6 12.41 8.81 12.23 9.03 12.07C9.14 11.99 9.25 11.91 9.37 11.83C9.6 11.67 9.85 11.51 10.11 11.36C12.11 13.23 14.65 15.43 14.69 15.46Z" fill="url(#nk_grad)"/>
    <path d="M14.76 4.62L14.74 5.76L14.72 6.33L14.7 7.47L14.68 8.05L14.66 9.19C14.62 9.21 12.07 10.19 10.11 11.36C9.86 11.51 9.61 11.67 9.38 11.83C9.26 11.91 9.14 11.99 9.04 12.07C8.82 12.23 8.61 12.41 8.42 12.6C8.33 12.68 8.25 12.78 8.17 12.88C7.99 13.1 7.89 13.32 7.87 13.53L7.89 12.58V12.57L7.9 12.42V12.37L7.91 11.77L7.95 10.58L7.96 10L7.99 8.81C8.4 7.16 14.09 4.88 14.76 4.62Z" fill="white" opacity="0.9"/>
    <circle cx="9.51" cy="4.21" r="1.67" fill="white" opacity="0.9"/>
    <defs>
      <linearGradient id="nk_grad" x1="13.53" y1="17.19" x2="6.92" y2="9.56" gradientUnits="userSpaceOnUse">
        <stop stopColor="white"/><stop offset="1" stopColor="currentColor"/>
      </linearGradient>
    </defs>
  </svg>
);

// Coding Blocks — transparent webp icon
export { default as CodingBlocksIcon } from "../logos/coding-blocks.webp";

// React Native Elements — use actual logo image
export { default as ReactNativeIcon } from "../logos/react-native-elements.png";
